import axios from "axios";
import config from "./config";

const interceptorId = null;

const axiosInstance = axios.create({
	baseURL: config.baseURL,
	// Add any default headers or interceptors here
});

function removeAxiosInterceptor() {
    interceptorId && axiosInstance.interceptors.request.eject(interceptorId);
}

function setAxiosInterCeptor(configObj) {
    axiosInstance.interceptors.request.use(
     config => {
       if (configObj.token) {
         config.headers.Authorization = `Bearer ${configObj.token}`;
       }
       return config;
     }
   );
}

const _handleSuccess = (response) => response?.data;
const _handleError = (error) => error?.response?.data;

/**
 * @description {Method to get data from the server}
 * @param url {String}
 * @returns Promise<unknown>
 */
const getRequest = (url) => axiosInstance.get(url).then(_handleSuccess).catch(_handleError);

/**
 * @description {Method to post data to the server}
 * @param url {String}
 * @param payload {unknown}
 * @returns Promise<unknown>
 */
const postRequest = (url, payload) =>
	axiosInstance.post(url, payload).then(_handleSuccess).catch(_handleError);

/**
 * @description {Method to put data to the server}
 * @param url {String}
 * @param payload {unknown}
 * @returns Promise<unknown>
 */
const putRequest = (url, payload) =>
	axiosInstance.put(url, payload).then(_handleSuccess).catch(_handleError);

/**
 * @description {Method to patch data to the server}
 * @param url {String}
 * @param payload {unknown}
 * @returns Promise<unknown>
 */
const patchRequest = (url, payload) =>
	axiosInstance.patch(url, payload).then(_handleSuccess).catch(_handleError);

/**
 * @description {Method to delete data from the server}
 * @param url {String}
 * @returns Promise<unknown>
 */
const deleteRequest = (url) => axiosInstance.delete(url).then(_handleSuccess).catch(_handleError);

export default axiosInstance;
export { getRequest, postRequest, putRequest, deleteRequest, patchRequest, setAxiosInterCeptor, removeAxiosInterceptor };
